import * as Yup from "yup";
import isEmail from "validator/lib/isEmail";

Yup.addMethod(Yup.string, "mailNest", function (message) {
  return this.test("mailNest", message || "無効なメールです。", (value) => {
    return !value || isEmail(value);
  });
});
